import global from './global/fr-FR'
import { login } from './page/fr-FR'
import {
  articleEdit,
  articleArchivedTablePagination,
  articleListFilter,
  forgotPassword,
  header,
  modalConfirmPropagateModification,
  selectFilterArticleImport,
  selectFilterArticleSource,
  selectFilterArticlePublishDate,
  tablePagination
} from './component/fr-FR'
import {
  validationForgotPassword,
  customerUser,
  customer,
  customerSource,
  customerApiUser,
  user,
  author,
  dropbox,
  keyword,
  mailingList,
  mailingRecipient,
  mailingTemplate,
  passwordRenewal,
  pressReview,
  source,
  financialEntity,
  financialIndicator,
  statsExportsCustomersEditors
} from './validation/fr-FR'

export default {
  global,
  page: {
    login
  },
  component: {
    articleArchivedTablePagination,
    articleEdit,
    articleListFilter,
    forgotPassword,
    header,
    modalConfirmPropagateModification,
    selectFilterArticleImport,
    selectFilterArticleSource,
    selectFilterArticlePublishDate,
    tablePagination
  },
  validation: {
    customerUser,
    customer,
    customerSource,
    customerApiUser,
    user,
    author,
    dropbox,
    keyword,
    mailingList,
    mailingRecipient,
    mailingTemplate,
    passwordRenewal,
    pressReview,
    source,
    financialEntity,
    financialIndicator,
    statsExportsCustomersEditors
  },
  validationForgotPassword
}
